import { Button, Empty, Input, Tooltip } from "antd"
import { BsArrowDownUp } from "react-icons/bs";
import { TranslateString } from "Utils/Common"
import { DeleteOutlined, EditOutlined } from '@ant-design/icons';

const NewLoanList = (props: any) => {

    const onSearch = (event: any) => {
        const { target } = event;
        const value = target.value;
        const { name } = target;

        props.setSearchData({ ...props.searchData, [name]: value });
    };

  return (
    <>
            <div className="d-flex">
                <div className="ms-auto mb-1">
                    <Button className="btn btn-sm btn-light px-3 cu-btn-green" onClick={() => {
                        props?.setEditId("")
                        props?.setEditValue("")
                        props.setOpen(true)
                    }
                        }>{TranslateString('create_loan')}</Button>
                </div>
            </div>
            <div className='cu-table-border'>
                <table className="table table-sm table-bordered table-striped text-left m-0">
                    <thead>
                        <tr className="align-middle cu-text-small">
                            <td className="cu-bg-green fw-bold">{TranslateString('name_of_the_loan')}</td>
                            <td className="cu-bg-green fw-bold text-right">{TranslateString('estimated_amount_of_capital')}</td>
                            <td className="cu-bg-green fw-bold">{TranslateString('reason_for_the_loan')}</td>
                            <td className="cu-bg-green fw-bold text-center">{TranslateString('actions')}</td>
                        </tr>
                        <tr className="align-middle">
                            <td className="cu-bg-green" style={{width:"7%"}}><Input placeholder={TranslateString('search')} suffix={<BsArrowDownUp
                                onClick={() => {
                                    props.setSearchData({ ...props.searchData, sort_by: "bank_name" })
                                    props.setSort(!props.sort)
                                }
                                }
                                role={"button"} />} onChange={onSearch} name="bank_name" /></td>
                            <td className="cu-bg-green" style={{width:"7%"}}><Input placeholder={TranslateString('search')} onChange={onSearch} name="city_id" /></td>
                            <td className="cu-bg-green" style={{width:"7%"}}><Input placeholder={TranslateString('search')} onChange={onSearch} suffix={<BsArrowDownUp
                                onClick={() => {
                                    props.setSearchData({ ...props.searchData, sort_by: "city_name" })
                                    props.setSort(!props.sort)
                                }
                                }
                                role={"button"} />} name="city_name" /></td>
                            <td className="cu-bg-green" style={{width:"7%"}}></td>
                        </tr>
                    </thead>
                    <tbody className="cu-text-small">
                        <tr>
                            <td className="">New loan: Roof renovation loan</td>
                            <td className="text-right">5 897,10 €</td>
                            <td>Testataan kilpailutusta t. isännöitsijä</td>
                            <td className="text-center" role='button'>
                                <div className="d-flex justify-content-center">
                                    <div>
                                        <Tooltip title={TranslateString('delete')}>
                                            <DeleteOutlined
                                                className="m-0 cu-font-bold cu-font-cancel"
                                            />
                                        </Tooltip>
                                    </div>
                                    <div>&nbsp;</div>
                                    <div>
                                        <Tooltip title={TranslateString('edit')}>
                                            <EditOutlined
                                                className="fs-5"
                                            />
                                        </Tooltip>
                                    </div>
                                </div>
                            </td>
                        </tr>

                        <tr>
                            <td className="">New loan: Roof renovation loan</td>
                            <td className="text-right">6 157,10 €</td>
                            <td>Testataan kilpailutusta t. isännöitsijä</td>
                            <td className="text-center" role='button'>
                                <div className="d-flex justify-content-center">
                                    <div>
                                        <Tooltip title={TranslateString('delete')}>
                                            <DeleteOutlined
                                                className="m-0 cu-font-bold cu-font-cancel"
                                            />
                                        </Tooltip>
                                    </div>
                                    <div>&nbsp;</div>
                                    <div>
                                        <Tooltip title={TranslateString('edit')}>
                                            <EditOutlined
                                                className="fs-5"
                                            />
                                        </Tooltip>
                                    </div>
                                </div>
                            </td>
                        </tr>

                        <tr>
                            <td className="">New loan: Roof renovation loan</td>
                            <td className="text-right">8 297,10 €</td>
                            <td>Testataan kilpailutusta t. isännöitsijä</td>
                            <td className="text-center" role='button'>
                                <div className="d-flex justify-content-center">
                                    <div>
                                        <Tooltip title={TranslateString('delete')}>
                                            <DeleteOutlined
                                                className="m-0 cu-font-bold cu-font-cancel"
                                            />
                                        </Tooltip>
                                    </div>
                                    <div>&nbsp;</div>
                                    <div>
                                        <Tooltip title={TranslateString('edit')}>
                                            <EditOutlined
                                                className="fs-5"
                                            />
                                        </Tooltip>
                                    </div>
                                </div>
                            </td>
                        </tr>

                    </tbody>
                </table>
            </div>
        </>
  )
}

export default NewLoanList